import {Injectable} from '@angular/core';
import {APIHelper} from '../../../../../shared/services/api-helper/api-helper.service';
import {API_URLS} from '../../../../../environments/env-routes';

import {filter} from 'rxjs/operators';
import {RouterEvent, Event, Router} from '@angular/router';
import {SiteContextService} from 'src/shared/services/site/site-context.service';
import { CmmService } from 'src/app/+home/+aspects/cmm-service.service';

class SearchQueryBuilder {
  constructor(initQuery: string) {
    this.query = this.sanitize(initQuery);
  }

  private _query;

  get query() {
    return this._query;
  }

  set query(value) {
    this._query = value;
  }

  and(query: string) {
    query = this.sanitize(query);
    if (query.length) {
      this.query = this.infixQuery('AND', query);
    }
    return this.query;
  }

  or(query: string) {
    query = this.sanitize(query);
    if (query.length) {
      this.query = this.infixQuery('OR', query);
    }
    return this.query;
  }

  not(query: string) {
    query = this.sanitize(query);
    if (query.length) {
      this.query = this.infixQuery('NOT', query);
    }
    return this.query;
  }

  infixQuery(infix: string, query) {
    return `${this.query} ${infix} (${query})`;
  }

  toString() {
    return this.query;
  }

  sanitize(query) {
    return query.trim();
  }
}

@Injectable({
  providedIn: 'root'
})
export class SearchService {
  public searchTerm = '';
  public config: any;
  public actualSite: any;

  constructor(
    public router: Router,
    private api: APIHelper,
    private siteContext: SiteContextService,
    private cmmService: CmmService
  ) {
    this.config = {
      includePersons: false,
      includeDiscussions: false,
      allSites: false
    };
    this.siteContext.currentSite$.pipe(filter(site => site !== null))
      .subscribe(site => {
        this.actualSite = site;
      });
    // router.events.pipe(
    //   filter((e: Event): e is RouterEvent => e instanceof RouterEvent)
    // ).subscribe((e: RouterEvent) => {
    //   if (!e.url.includes('/home/my-libraries/lib/')) {
    //     this.actualSite = null;
    //   }
    // });
  }

  public search({query, paging}: { query: string; paging?: { skipCount: number, maxItems: number } }) {
    const pagingParam = paging ? paging : {skipCount: 0, maxItems: 20};
    const param = {
      query: {
        query: query
        // query: 'TYPE:person AND cm:person:"*"',
        // language: 'afts'
      },
      include: ['path', 'allowableOperations', 'properties'],
      paging: pagingParam,
      // rootNode: '8bb36efb-c26d-4d2b-9199-ab6922f53c28',
      filterQueries: [
        {
          query: '+TYPE:\'cm:folder\' OR +TYPE:\'cm:content\' OR +TYPE:\'cm:person\''
        },
        // {query: '-TYPE:\'cm:person\''},
        {
          query: '-TYPE:\'cm:thumbnail\' AND -TYPE:\'bpm:package\' AND -TYPE:\'cm:systemfolder\' AND -TYPE:\'cm:failedThumbnail\' ' +
            'AND -TYPE:\'cm:rating\''
        },
        // { query: '-cm:creator:System AND -QNAME:comment' },
        {
          query:
            '-TYPE:\'st:site\' AND -ASPECT:\'st:siteContainer\' AND -ASPECT:\'sys:hidden\''
        },
        {
          query:
            '-TYPE:\'dl:dataList\' AND -TYPE:\'dl:todoList\' AND -TYPE:\'dl:issue\''
        },
        {query: '-TYPE:\'fm:topic\' AND -TYPE:\'fm:post\''},
        {query: '-TYPE:\'lnk:link\''},
        {query: '-PNAME:\'0/wiki\''}
      ],
      facetQueries: [
        {
          label: 'SEARCH.FACET_QUERIES.TODAY',
          query: 'cm:modified:[TODAY to TODAY]',
          group: 'SEARCH.CATEGORIES.MODIFIED_DATE'
        },
        {
          label: 'SEARCH.FACET_QUERIES.THIS_WEEK',
          query: 'cm:modified:[NOW/DAY-7DAYS TO NOW/DAY+1DAY]',
          group: 'SEARCH.CATEGORIES.MODIFIED_DATE'
        },
        {
          label: 'SEARCH.FACET_QUERIES.THIS_MONTH',
          query: 'cm:modified:[NOW/DAY-1MONTH TO NOW/DAY+1DAY]',
          group: 'SEARCH.CATEGORIES.MODIFIED_DATE'
        },
        {
          label: 'SEARCH.FACET_QUERIES.LAST_6_MONTHS',
          query: 'cm:modified:[NOW/DAY-6MONTHS TO NOW/DAY+1DAY]',
          group: 'SEARCH.CATEGORIES.MODIFIED_DATE'
        },
        {
          label: 'SEARCH.FACET_QUERIES.THIS_YEAR',
          query: 'cm:modified:[NOW/DAY-1YEAR TO NOW/DAY+1DAY]',
          group: 'SEARCH.CATEGORIES.MODIFIED_DATE'
        }
      ],
      facetIntervals: null,
      facetFields: {
        facets: [
          {field: 'content.mimetype', label: 'SEARCH.FACET_FIELDS.FILE_TYPE'},
          {field: 'creator', label: 'SEARCH.FACET_FIELDS.CREATOR'},
          {field: 'modifier', label: 'SEARCH.FACET_FIELDS.MODIFIER'},
          {field: 'SITE', label: 'SEARCH.FACET_FIELDS.LOCATION'}
        ]
      },
      sort: [{type: 'FIELD', field: 'score', ascending: false}],
      highlight: null,
      facetFormat: 'V2'
    };
    return this.api.requestApi({
      action: API_URLS.search.search,
      method: 'POST',
      datas: param
    });
  }

  public searchGroupAndUser(searchTerm) {
    const searchtrim=searchTerm.trim();
    const param = {
      query: {
        query:
        'authorityName:*' + searchtrim + '* OR userName:*' + searchtrim + '* OR firstName:*'+searchtrim +'* OR lastName:*'+searchtrim+'*'
      },
      include: ['properties', 'aspectNames'],
      paging: {maxItems: 500, skipCount: 0},
      filterQueries: [{query: 'TYPE:\'cm:authority\''}]
    };

    return this.api.requestApi({
      action: API_URLS.search.search,
      method: 'POST',
      datas: param
    });
  }

  public searchUser(searchTerm) {
    const param = {
      query: {
        query:
          'userName:*' + searchTerm + '*'
      },
      include: ['properties', 'aspectNames'],
      paging: {maxItems: 500, skipCount: 0},
      filterQueries: [{query: 'TYPE:\'cm:authority\''}]
    };

    return this.api.requestApi({
      action: API_URLS.search.search,
      method: 'POST',
      datas: param
    });
  }

  public searchGroupAndUserForClient(searchTerm, organisation) {
    const param = {
      query: {
        query:
          'authorityName:*' + searchTerm + '* OR userName:*' + searchTerm + '*' + ' AND organization:*' + organisation + '*'
      },
      include: ['properties', 'aspectNames'],
      paging: {maxItems: 500, skipCount: 0},
      filterQueries: [{query: 'TYPE:\'cm:person\''}]
    };

    return this.api.requestApi({
      action: API_URLS.search.search,
      method: 'POST',
      datas: param
    });
  }

  escapeRegex(string) {
    const re = /[-\/\\^$*+?.()|[\]{}]/g;
    const skipTerm = '';
    let found;

    do {
      found = re.exec(string);
      if (found) {

        return skipTerm;
      } else {
        return string.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
      }
    } while (found);
  }

  sanitizeSearchTerm(searchTerm: string) {
    searchTerm = searchTerm.trim();
    searchTerm = this.escapeRegex(searchTerm);

    return searchTerm;
  }

  private getQuerySearchForAllAspects(searchString: string) {
    const allSubAspects = [];
    for(let aspect of this.cmmService.loadedAspects) {
      if(!aspect.entry.properties && !aspect.entry.properties.length) {
        continue;
      }

      for(let property of aspect.entry.properties) {
        // Ne garder que les chaine de caractère car le user effectue une recherche en chaine de caractère
        if(property.dataType === 'd:text') {
          allSubAspects.push(property.prefixedName);
        }
      }
    }

    return allSubAspects
            .map(aspName => `${aspName}:"*${searchString}*"`)
            .join(' OR ');
  }

  public generateQuery(
    search: string,
    filters: any,
    configSearch: {
      includePersons: boolean;
      site?: { id: string, name: string }
    }
  ) {
    search = this.sanitizeSearchTerm(this.searchTerm);
    let query = '';

    if (filters) {
      query += this.getSizeQuery(filters);
      query += this.getGenericCheckboxQuery(filters, {
        filterName: 'fileTypes',
        nameProperty: 'content.mimetype'
      });
      query += this.getGenericCheckboxQuery(filters, {
        filterName: 'creators',
        nameProperty: 'creator'
      });
      query += this.getGenericCheckboxQuery(filters, {
        filterName: 'modifiers',
        nameProperty: 'modifier'
      });
      query += this.getGenericDateQuery(filters, {
        filterName: 'creationDate',
        nameProperty: 'cm:created'
      });
      query += this.getGenericDateQuery(filters, {
        filterName: 'modifyDate',
        nameProperty: 'cm:modified'
      });
    
    }
    let queryToAdd = '';
    if (configSearch.includePersons) {
      queryToAdd = `)) OR ((PATH:"/sys:system/sys:people//*") and TYPE:"cm:person" and ( cm:userName:"*${search}*" or cm:name:"*${search}*" or cm:lastName:"*${search}*" `;
    }
    let specificSiteQuery = '';
    // let specificSiteQuery = `(PATH:"/app:company_home/st:sites/cm:*/cm:documentLibrary//*") AND`;
 
    if (configSearch.site) {
      specificSiteQuery = `(PATH:"/app:company_home/st:sites/cm:${configSearch.site.name}/cm:documentLibrary//*") AND `;
    } else {
      specificSiteQuery = `(PATH:"/app:company_home/st:sites/cm:*/cm:documentLibrary//*") AND`;
    }

    const aspectQuery = this.getQuerySearchForAllAspects(search);
    
    let addQueryForAspects = '';
    if(aspectQuery) {
      addQueryForAspects = `OR ${aspectQuery}`;
    }

    query =
      `( ${specificSiteQuery} (cm:name:"*${search}*" OR cm:title:"*${search}*" OR ` +
      `cm:description:"*${search}*" OR TEXT:"*${search}*" ${addQueryForAspects} OR TAG:"*${search}*" ${queryToAdd})` +
      query +
      ' )';
    return query;
  }

  private getGenericDateQuery(
    filters,
    {
      filterName,
      nameProperty
    }: {
      filterName: string;
      nameProperty: string;
    }
  ) {
    const {begin, end} = filters[filterName];

    if (!begin || !end) {
      return '';
    }

    // AND (cm:created:['2019-07-03T00:00:00+02:00' TO '2019-07-15T23:59:59+02:00'])
    const result = `cm:created:['${begin.toISOString()}' TO '${end.toISOString()}']`;

    // Ne rien renvoyé si aucune checkbox n'a été cochée
    return result ? ' AND (' + result + ') ' : '';
  }

  private getGenericCheckboxQuery(
    filters,
    {
      filterName,
      nameProperty
    }: {
      filterName: string;
      nameProperty: string;
    }
  ) {
    let result = '';

    for (const el in filters[filterName]) {
      if (!filters[filterName][el]) {
        continue;
      }

      if (result) {
        result += ' OR ';
      }

      result += nameProperty + ':"' + el + '"';
    }

    // Ne rien renvoyé si aucune checkbox n'a été cochée
    return result ? ' AND (' + result + ') ' : '';
  }

  private getSizeQuery(filters) {
    if (
      !filters.size.small &&
      !filters.size.medium &&
      !filters.size.big &&
      !filters.size.veryBig
    ) {
      return '';
    }

    let result = '';

    if (filters.size.small) {
      result += ' content.size:[0 TO 1048576> ';
    }

    if (filters.size.medium) {
      if (result) {
        result += ' OR ';
      }
      result += ' content.size:[1048576 TO 52428800] ';
    }

    if (filters.size.big) {
      if (result) {
        result += ' OR ';
      }
      result += ' content.size:<52428800 TO 524288000] ';
    }

    if (filters.size.veryBig) {
      if (result) {
        result += ' OR ';
      }
      result += ' content.size:<524288000 TO MAX] ';
    }

    result = ' AND (' + result + ') ';
    return result;
  }
}
